// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";

function isLocalStorageAvailable(param) {
  return (function() {
    let isLocalStorageAvailable = false
    try {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('feature_test', 'yes');
            if (localStorage.getItem('feature_test') === 'yes') {
                localStorage.removeItem('feature_test');
                isLocalStorageAvailable = true
            } else {
                isLocalStorageAvailable = false
            }
        } else {
            isLocalStorageAvailable = false
        }
    } catch (e) {
        isLocalStorageAvailable = false
    }
    return isLocalStorageAvailable
}());
}

var checkMultipleUrlParams = (function (url_param) {
if (typeof url_param === 'string') {
  return url_param;
} else if (Array.isArray(url_param) && url_param.length > 0) {
  return url_param[0];
} else {
  return null;
}
});

var androidDismiss = (function androidDismiss() {
    if(typeof Android != "undefined" && typeof Android.dismiss != "undefined")
      Android.dismiss()
    });

function iosDismiss(param) {
  JsBindings$PorterinUtils.redirect("ios://webToNativeCall/dismiss");
}

var isAndroid = (function isAndroid() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    ua = ua.toLowerCase()
    return (ua.indexOf("android") > -1);
  });

var isIos = (function isIOS() {
    var flag = /iPad|iPhone|iPod/.test(navigator.platform)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    return flag;
  });

var isWebView = (function isWebView() {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
      return false;
    }

    // Check for Android WebView
    if (typeof Android !== 'undefined') {
      return true;
    }

    // Check for iOS WebView
    if (window && window.webkit && window.webkit.messageHandlers) {
      return true;
    }

    return false;
  });

var openNativeURLAndroid = (function openURL(url) {
         if (typeof Android !== 'undefined' && Android.openUrlNative) {
           Android.openUrlNative(url)
         } else {
           window.location.href = url
         }
      });

function openNativeUrlIos(url) {
  JsBindings$PorterinUtils.redirect("ios://xyz.xyz/openUrlNative?redirectUrl=" + url);
}

function openNativeUrl(cta_link) {
  if (Curry._1(isAndroid, undefined)) {
    return openNativeURLAndroid(cta_link);
  } else {
    return JsBindings$PorterinUtils.redirect(cta_link);
  }
}

export {
  isLocalStorageAvailable ,
  checkMultipleUrlParams ,
  androidDismiss ,
  iosDismiss ,
  isAndroid ,
  isIos ,
  isWebView ,
  openNativeURLAndroid ,
  openNativeUrlIos ,
  openNativeUrl ,
}
/* JsBindings-PorterinUtils Not a pure module */
